import { render, staticRenderFns } from "./roller.vue?vue&type=template&id=4d5b97c0&scoped=true&"
import script from "./roller.vue?vue&type=script&lang=js&"
export * from "./roller.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d5b97c0",
  null
  
)

export default component.exports